// BlogEditor.js
import React, { useState, useEffect } from 'react';

function BlogEditor({ language, user, countryCode, userIp }) {
  const [htmlContent, setHtmlContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadHtmlFile = async () => {
      try {
        const response = await fetch('/html/blogEditor.html');
        const content = await response.text();
        setHtmlContent(content);
      } catch (error) {
        console.error('HTML 파일 로드 실패:', error);
        setHtmlContent('<p>파일을 불러올 수 없습니다.</p>');
      } finally {
        setLoading(false);
      }
    };

    loadHtmlFile();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <p>로딩 중...</p>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <iframe
        srcDoc={htmlContent}
        style={{
          width: '100%',
          height: '100%',
          border: 'none'
        }}
        title="Blog Editor"
      />
    </div>
  );
}

export default BlogEditor;